module.exports = __webpack_public_path__ + "static/img/btn_2.b2262e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new/btn_2.png
// module id = 2Ima
// module chunks = 1